import React from 'react';
import { Redirect, Route, Switch, withRouter } from 'react-router-dom';
import { compose, pure } from 'recompose';
import { routes } from '../../../constants';
import { AdminArtist, AdminArtists, AdminEvent, AdminEvents, NotFound } from '../../pages';
import { AdminNav, Footer } from '../../partials';
import './admin-portal.css';

const AdminPortal = () => (
  <section className='admin-portal'>
    <header>
      <AdminNav />
    </header>
    <main>
      <Switch>
        <Route
          exact
          path={routes.adminPortal.root}
          component={() => <Redirect to={routes.adminPortal.artists} />} />
        <Route path={routes.adminPortal.artist()} component={AdminArtist} />
        <Route path={routes.adminPortal.artists} component={AdminArtists} />
        <Route path={routes.adminPortal.event()} component={AdminEvent} />
        <Route path={routes.adminPortal.events} component={AdminEvents} />
        <Route component={NotFound} />
      </Switch>
    </main>
    <Footer />
  </section>
);

export default compose(
  withRouter,
  pure
)(AdminPortal);



// WEBPACK FOOTER //
// ./src/components/layouts/admin-portal/admin-portal.js